"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _reactRouterDom = require("react-router-dom");

/**
 * A route that can only be displayed if the conditional is met.
 * Otherwise it redirects to a given route while preserving query params.
 */
var GatedRoute = function GatedRoute(_ref) {
  var Component = _ref.component,
      conditional = _ref.conditional,
      redirect = _ref.redirect,
      props = (0, _objectWithoutProperties2.default)(_ref, ["component", "conditional", "redirect"]);
  var location = (0, _reactRouterDom.useLocation)();
  var urlSearchParams = new URLSearchParams(location.search);
  return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, Object.assign({}, props, {
    render: function render(routeProps) {
      return conditional === true ? /*#__PURE__*/_react.default.createElement(Component, Object.assign({}, props, routeProps)) : /*#__PURE__*/_react.default.createElement(_reactRouterDom.Redirect, {
        to: {
          pathname: redirect,
          search: "?".concat(urlSearchParams.toString())
        }
      });
    }
  }));
};

GatedRoute.defaultProps = {
  props: {}
};
var _default = GatedRoute;
exports.default = _default;